<app-menu>
  <div class="dt-shell min-h-full bg-[var(--dt-bg)] text-[var(--dt-text-main)]" [attr.data-theme]="themeMode">
    <div class="mx-auto flex h-[calc(100vh-64px)] min-h-[calc(100vh-64px)] min-w-0 max-w-[1800px] flex-col gap-4 px-4 pb-5 pt-4 sm:px-5 lg:px-6">
      <section class="relative overflow-hidden rounded-3xl border border-[var(--dt-border)] bg-[var(--dt-surface)] shadow-[0_18px_48px_rgba(2,6,23,0.16)]">
        <div class="relative flex flex-col gap-5 px-4 py-4 sm:px-5 lg:px-6 xl:flex-row xl:items-start xl:justify-between">
          <div class="min-w-0 flex-1 space-y-4">
            <div class="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
              <div class="flex min-w-0 flex-wrap items-center gap-3">
                <h1 class="text-3xl font-black text-[var(--dt-text-main)]">Drop Trailers</h1>
                <span *ngIf="analyticsLoading" class="dt-analytics-state">Analytics...</span>
                <span *ngIf="!analyticsLoading && analyticsError" class="dt-analytics-state dt-analytics-state--warn">Grid fallback</span>
              </div>
            </div>

            <div class="grid gap-2 sm:grid-cols-2 xl:grid-cols-4">
              <button
                type="button"
                *ngFor="let insight of dropTrailerInsights"
                class="dt-insight rounded-2xl border px-3 py-2 text-left shadow-sm transition"
                [class.is-active]="isInsightActive(insight.key)"
                [attr.aria-label]="insight.description"
                [attr.aria-pressed]="isInsightActive(insight.key)"
                [ngClass]="
                  insight.tone === 'rose'
                    ? 'border-rose-500/20 bg-rose-500/10 hover:border-rose-400/40'
                    : insight.tone === 'amber'
                      ? 'border-amber-500/20 bg-amber-500/10 hover:border-amber-400/40'
                      : insight.tone === 'sky'
                        ? 'border-sky-500/20 bg-sky-500/10 hover:border-sky-400/40'
                        : 'border-emerald-500/20 bg-emerald-500/10 hover:border-emerald-400/40'
                "
                (click)="applyInsightFilter(insight.key)"
              >
                <div class="flex items-start justify-between gap-3">
                  <div class="min-w-0 flex items-baseline gap-2">
                    <p class="text-[10px] font-bold uppercase tracking-[0.16em] text-[var(--dt-text-secondary)]">{{ insight.title }}</p>
                    <p class="text-xl font-black leading-none text-[var(--dt-text-main)]">{{ insight.value | number }}</p>
                  </div>

                  <span
                    class="inline-flex h-7 w-7 flex-none items-center justify-center rounded-xl text-xs"
                    [ngClass]="
                      insight.tone === 'rose'
                        ? 'bg-rose-500/10 text-rose-500'
                        : insight.tone === 'amber'
                          ? 'bg-amber-500/10 text-amber-500'
                          : insight.tone === 'sky'
                            ? 'bg-sky-500/10 text-sky-500'
                            : 'bg-emerald-500/10 text-emerald-500'
                    "
                  >
                    <i class="fa-solid" [ngClass]="insight.icon"></i>
                  </span>
                </div>

                <div class="mt-2 flex min-w-0 flex-wrap gap-1.5">
                  <span *ngFor="let fact of insight.facts" class="dt-insight-fact">
                    <span>{{ fact.label }}</span>
                    <strong>{{ fact.value }}</strong>
                  </span>
                </div>
              </button>
            </div>
          </div>

          <div class="flex w-full flex-col gap-2 xl:w-[372px] xl:min-w-[372px]">
            <label class="dt-search flex items-center gap-3 rounded-2xl border border-[var(--dt-border)] bg-[var(--dt-surface-2)] px-4 py-2.5 shadow-sm">
              <i class="fa-solid fa-magnifying-glass text-sm text-[var(--dt-text-secondary)]"></i>
              <input
                type="text"
                id="universalFilter"
                [(ngModel)]="universalFilter"
                (ngModelChange)="onFilterTextBoxChanged()"
                placeholder="Search drop trailers"
                class="min-w-0 flex-1 border-0 bg-transparent p-0 text-sm font-semibold text-[var(--dt-text-main)] outline-none placeholder:text-[var(--dt-text-secondary)]"
              >
            </label>

            <div class="grid grid-cols-2 gap-2">
              <button type="button" (click)="resetSavedView()" [disabled]="loading" class="dt-button">
                <i class="fa-solid fa-rotate-left text-sm"></i>
                Reset View
              </button>

              <button type="button" (click)="toggleColumnsPanel()" class="dt-button">
                <i class="fa-solid fa-table-columns text-sm"></i>
                Columns
              </button>
            </div>

            <div class="grid grid-cols-2 gap-2">
              <button type="button" (click)="exportGrid()" [disabled]="loading" class="dt-button">
                <i class="fa-solid fa-file-excel text-sm"></i>
                Export
              </button>

              <button type="button" (click)="toggleTheme()" class="dt-button">
                <i [class]="getThemeIcon()"></i>
                {{ getThemeLabel() }}
              </button>
            </div>

            <div class="grid grid-cols-2 gap-2">
              <button type="button" (click)="refreshData()" [disabled]="loading" class="dt-button dt-button--primary">
                <i class="fa-solid fa-rotate text-sm"></i>
                Refresh
              </button>

              <button *ngIf="!carrierLimitedMode" type="button" (click)="addDropTrailer()" class="dt-button dt-button--accent">
                <i class="fa-solid fa-plus text-sm"></i>
                Add
              </button>
            </div>
          </div>
        </div>
      </section>

      <div *ngIf="errorMessage" class="flex items-start gap-3 rounded-2xl border border-red-500/20 bg-red-500/10 px-4 py-3 text-sm text-red-500 shadow-sm">
        <span class="mt-0.5 text-base">&#x26A0;</span>
        <div class="min-w-0 flex-1">
          <p class="font-semibold">Grid load issue</p>
          <p class="mt-1 text-red-500/90">{{ errorMessage }}</p>
        </div>
        <button class="rounded-full p-1 transition hover:bg-red-500/10" (click)="errorMessage = ''">&#x2715;</button>
      </div>

      <div *ngIf="loading" class="flex items-center gap-3 rounded-2xl border border-[var(--dt-border)] bg-[var(--dt-surface)] px-4 py-3 text-sm text-[var(--dt-text-secondary)] shadow-sm">
        <div class="dt-spinner"></div>
        <span>Loading drop trailers&hellip;</span>
      </div>

      <div class="dt-grid-shell flex-col overflow-hidden rounded-[28px] border border-[var(--dt-border)] bg-[var(--dt-surface)] shadow-[0_18px_50px_rgba(2,6,23,0.14)]">
        <div class="relative min-h-0 flex-1">
          <div class="pointer-events-none absolute inset-x-0 top-0 z-[1] h-16 bg-[linear-gradient(180deg,rgba(14,165,233,0.06),transparent)]"></div>
          <ag-grid-angular
            *ngIf="gridReady"
            [class]="themeClass"
            class="dt-grid"
            [style.opacity]="loading ? 0.45 : 1"
            [gridOptions]="gridOptions"
            [rowModelType]="rowModelType"
            [rowData]="rowData"
            (gridReady)="onGridReady($event)"
            [initialState]="initialState"
            (stateUpdated)="onStateUpdated($event)"
          ></ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</app-menu>
